import { render, staticRenderFns } from "./HomeScreen.vue?vue&type=template&id=107b8134&scoped=true"
import script from "./HomeScreen.vue?vue&type=script&lang=js"
export * from "./HomeScreen.vue?vue&type=script&lang=js"
import style0 from "./HomeScreen.vue?vue&type=style&index=0&id=107b8134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107b8134",
  null
  
)

export default component.exports